import EditPeopleGroup from './EditPeopleGroup';

export default EditPeopleGroup;
